window.onResume = () => {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistration().then(registration => {
            if (registration && registration.active) {
                registration.update();
            }
        });
    }
};
